import useTimeZoneClock from 'hooks/useTimeZoneClock';
import { getBackgroundStyle } from 'components/common/TableColor';
import moment from 'moment';
import React from 'react'

const ViewTable = React.memo(({ item, isInterpreter }) => {

    const timeZone = useTimeZoneClock(item?.datetime);
    const formattedDate = moment(timeZone).format('MMMM DD YYYY');
    const formattedTime = moment(timeZone).format('hh:mm A');

    const InfoRow = ({ label, value, toLowerCase = "" }) => (
        <div className='row_detail_tab'>
            <div className='label_view'><strong>{label}</strong></div>
            <div className={`detail_view ${toLowerCase}`}>{value || 'N/A'}</div>
        </div>
    );
    const rowDash1Style = {
        display: 'flex',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const rowDash2Style = {
        display: 'block',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const marginTopZero = {
        marginTop: 0
    };

    const duration = (value) => {
        const hours = Math.floor(value / 60);
        const minutes = value % 60;
        if (minutes === 0) {
            return `${hours}hour${hours > 1 ? "s" : ""}`;
        }
        return `${hours}hr ${minutes.toString().padStart(2, "0")}min`;
    }

    const appointment = item;
    const apptDetails = appointment?.appointment_details;
    const apptInterpreter = item?.interpreter;

    const formatTime = (time) => {
        if (!time) return "";
        const date = new Date(`1970-01-01T${time}`);
        return date.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };

    return (

        <div className="Table_data_show Table_data_show1 p-0 overflow-auto">
            <div className="row_dash_1" style={rowDash1Style}>
                {/* {!isInterpreter && */}
                    <div className="card_table" style={marginTopZero}>
                        <div className="interpreter p-4">
                            <h2>Interpreter:</h2>
                        </div>
                        <div className="Table_data_show Table_data_show1 pt-0">
                            <table class="bg-primary-secondary table">
                                <tbody>
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>Interpreter Name: </td>
                                        <td className="bg-primary-secondary">
                                            {(apptInterpreter?.user?.name) || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>AOC Roster Name: </td>
                                        <td className="bg-primary-secondary">
                                            {(apptInterpreter?.display_name) || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>Interpreter Email: </td>
                                        <td class="bg-primary-secondary">{apptInterpreter?.user?.email || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>Interpreter Phone: </td>
                                        <td class="bg-primary-secondary">{apptInterpreter?.phone || 'N/A'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                {/* } */}
                <div className="card_table" style={marginTopZero}>
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-info-secondary table" style={getBackgroundStyle(appointment?.status)}>
                            <tbody>
                                <tr>
                                    <td className="bg-info-secondary" style={{ ...getBackgroundStyle(appointment?.status), width: "40%" }}>Status: </td>
                                    <td className="bg-info-secondary capitalize-status" style={getBackgroundStyle(appointment?.status)}>{appointment?.status}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary">Job Duration: </td>
                                    <td class="bg-primary-secondary" >{duration(item.duration)}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary">Simultaneous Interpretation: </td>
                                    <td class="bg-primary-secondary">{appointment?.simultaneous_interpretation == 1 ? 'Yes' : 'No'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
     
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Name: </td>
                                    <td class="bg-primary-secondary">{apptDetails?.requester_name || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Email: </td>
                                    <td class="bg-primary-secondary" toLowerCase={'text-lowercase'}>{apptDetails?.requester_email || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Phone:</td>
                                    <td class="bg-primary-secondary">{apptDetails?.requester_phone || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="row_dash_1" style={rowDash2Style}>
                <div className="Table_data_show Table_data_show1 pt-0 ">
                    <table class="bg-primary-secondary table">
                        <tbody>
                            <tr>
                                <td class="bg-primary-secondary col-2">Job Location: </td>
                                <td class="bg-primary-secondary col-4">{apptDetails?.job_location?.name || 'N/A'}</td>
                                <td class="bg-primary-secondary col-2">Location Address:</td>
                                <td class="bg-primary-secondary col-4">{apptDetails?.location_address || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary col-2">Location Notes:</td>
                                <td class="bg-primary-secondary" colSpan={3}>{apptDetails?.location_notes || 'N/A'}</td>
                            </tr>
                            <tr>
                                {!isInterpreter &&
                                    <>
                                        <td class="bg-primary-secondary col-2">Job Notes (internal):</td>
                                        <td class="bg-primary-secondary">{apptDetails?.job_notes_internal || 'N/A'}</td>
                                    </>
                                }
                                {/* <td class="bg-primary-secondary col-2">Job Notes {!isInterpreter ? '(external)' : ''}:</td>
                                <td class="bg-primary-secondary" colSpan={3}>{apptDetails?.job_notes_external || 'N/A'}</td> */}
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary col-2">Cancel reason: </td>
                                <td class="bg-primary-secondary" colSpan={3}>{apptDetails?.cancel_reason || 'N/A'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row_dash_1" style={rowDash2Style}>
                <div className="Table_data_show Table_data_show1 pt-0 ">
                    <table class="bg-primary-secondary table">
                        <tbody>
                            <tr>
                                <td class="bg-primary-secondary col-2">Checkin Date:</td>
                                <td class="bg-primary-secondary col-4" colSpan={2}>{item.appointment_assign?.checkin_date || 'N/A'}</td>
                                <td class="bg-primary-secondary col-2">Checkin Time:</td>
                                <td class="bg-primary-secondary col-4" colSpan={2}>{formatTime(item.appointment_assign?.checkin_time) || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary col-2">Checkout Date:</td>
                                <td class="bg-primary-secondary col-4" colSpan={2}>{item.appointment_assign?.checkout_date || 'N/A'}</td>
                                <td class="bg-primary-secondary col-2">Checkout Time:</td>
                                <td class="bg-primary-secondary col-4" colSpan={2}>{formatTime(item.appointment_assign?.checkout_time) || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary">Comments:</td>
                                <td class="bg-primary-secondary" colSpan={6}>{item.appointment_assign?.comments || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary">Notes:</td>
                                <td class="bg-primary-secondary" colSpan={6}>{item.appointment_assign?.notes || 'N/A'}</td>
                            </tr>
                            {item.appointment_assign && (
                              <tr>
                                <td class="bg-primary-secondary">Times Attested:</td>
                                <td class="bg-primary-secondary" colSpan={6}>
                                  {item.appointment_assign?.attested
                                    ? <span style={{ display: 'inline-block', padding: '1px 8px', fontSize: 12, fontWeight: 600, borderRadius: 10, background: '#1c2b2c33', color: '#1c2b2c' }}>Yes — interpreter certified the times</span>
                                    : <span style={{ display: 'inline-block', padding: '1px 8px', fontSize: 12, fontWeight: 600, borderRadius: 10, background: '#e33a3133', color: '#b51a12' }}>No</span>}
                                </td>
                              </tr>
                            )}
                            {item.appointment_assign?.auto_completed ? (
                              <tr>
                                <td class="bg-primary-secondary">Completion:</td>
                                <td class="bg-primary-secondary" colSpan={6}>
                                  <span style={{ display: 'inline-block', padding: '1px 8px', fontSize: 12, fontWeight: 600, borderRadius: 10, background: '#ffb82a', color: '#5a3d00' }}>⚙ Auto-completed by system (no check-in/out submitted)</span>
                                </td>
                              </tr>
                            ) : null}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )

})

export default ViewTable